import type { MstCommon } from '@libs/domain';

class BusinessConnectionMstSetting implements Pick<MstCommon['schema'], 'codeDigits'> {
  private constructor(readonly codeDigits: string) {}

  static fromRaw(raw: BusinessConnectionMstSettingRaw) {
    return new BusinessConnectionMstSetting(raw.codeDigits);
  }
}

class BusinessConnectionMstSettingRaw implements Pick<MstCommon['record'], 'codeDigits'> {
  private constructor(readonly codeDigits: string) {}

  static fromModel(mstInfoSetting: BusinessConnectionMstSetting) {
    return new BusinessConnectionMstSettingRaw(mstInfoSetting.codeDigits);
  }
}

export { BusinessConnectionMstSetting, BusinessConnectionMstSettingRaw };
